import "./styles.less";

import React, { useContext } from "react";

import { Col, Collapse, Radio, Row, Select, Skeleton, Space, Tooltip, Typography } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useOperationType } from "./OperationType.hook";
import { useTheme } from "../../../Styles/ThemeHook";
import { ConfigStateContext } from "../../../Contexts/Configurations/context";

const { Option } = Select;
const { Panel } = Collapse;

export const OperationType = ({ collapsable = false, home = false, ...props }) => {
	const { theme } = useTheme();
	const { country_code } = useContext(ConfigStateContext);
	const isCeee = country_code === "ce3";
	const {
		show,
		error,
		loading,
		inputType,
		label,
		labeled,
		data: { options, value, onChange, customKey },
	} = useOperationType(props);
	const { showSeasonInput, handleChangeSeason } = props;

	if (!show || error) return null;

	const opts = options ?? [];
	const optsSeason = [
		{
			value: 0,
			title: "Buscar por Calendario"
		},
		{
			value: 1,
			title: "Buscar por Temporada"
		}
	]

	const handleChange = e => {
		let val = e;
		const res = options.filter(o => o[customKey] == val);
		onChange(res[0]);
	};

	const textTooltip = "Filtro Activo";

	const extraIcon = () => (
		<Tooltip
			arrowPointAtCenter
			placement="topLeft"
			overlayInnerStyle={{ fontSize: 12, padding: 8 }}
			color={theme.colors.secondaryHoverColor}
			title={textTooltip}>
			<span className="active-filter"></span>
		</Tooltip>
	);

	const filterRadio = loading ? (
		<Space style={{ width: "100%" }} size={0} direction={"vertical"}>
			<Skeleton title={false} active paragraph={{ rows: 1, width: "100%" }} />
			<Skeleton title={false} active paragraph={{ rows: 1, width: "100%" }} />
			<Skeleton title={false} active paragraph={{ rows: 1, width: "100%" }} />
		</Space>
	) : (
		<Radio.Group onChange={e => handleChange(e.target.value)} value={value} disabled={loading}>
			<Row gutter={[0, theme.spacing.lgSpacing]}>
				{opts.map(o => (
					<Col span={24} key={`key_${o[customKey]}_operationType`}>
						<Radio value={o[customKey]}>{o.name}</Radio>
					</Col>
				))}
			</Row>
		</Radio.Group>
	);

	const filterButtons = loading ? (
		<Space style={{ width: "100%", justifyContent: "center" }} size={theme.spacing.xsSpacing}>
			<Skeleton.Button active shape="round" style={{ width: 170 }} />
			<Skeleton.Button active shape="round" style={{ width: 170 }} />
			<Skeleton.Button active shape="round" style={{ width: 170 }} />
		</Space>
	) : (
		isCeee ?  (
			<Radio.Group
				defaultValue={Number(showSeasonInput)}
				buttonStyle="solid"
				optionType="button"
				onChange={() => handleChangeSeason(!showSeasonInput)}
			>
				{optsSeason.map((option, index) => (
					<Radio.Button key={`button-season-${index}`} value={option.value}>{option.title}</Radio.Button>
				))}
			</Radio.Group>
		) : (
			<Radio.Group
				disabled={loading}
				onChange={e => handleChange(e.target.value)}
				optionType="button"
				buttonStyle={"solid"}
				value={value}>
				{opts.map(o => (
					<Radio.Button
						key={`key_buttons_${o[customKey]}_operationType`}
						value={o[customKey]}>
						{o.name}
					</Radio.Button>
				))}
			</Radio.Group>
		)
	);

	const filterSelect = loading ? (
		<Skeleton.Button active className="operation-type-skeleton" />
	) : (
		<Select
			disabled={loading}
				defaultValue={loading ? "Operación" : isCeee ? Number(showSeasonInput) : value}
				onChange={(e) => isCeee ? handleChangeSeason(!showSeasonInput) : handleChange(e)}
		>
			{isCeee
			? optsSeason.map((option, index) => (
				<Option key={`option-season-${index}`} value={option.value}>
					{option.title}
				</Option>
			))
			: opts.map(o => (
				<Option key={`key_select_${o[customKey]}_operationType`} value={o[customKey]}>
					{o.name}
				</Option>
			))}
		</Select>
	);

	let filter = filterButtons;
	if (inputType == "radioselect") filter = filterRadio;
	else if (inputType == "select") filter = filterSelect;

	return (
		<div className="filter operation-type-filter">
			{collapsable ? (
				<Collapse
					ghost
					bordered={false}
					defaultActiveKey={value ? "false" : "true"}
					expandIconPosition="right"
					expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}>
					<Panel
						extra={value && extraIcon()}
						disabled={loading}
						header={"Tipo de Operación"}
						key="true">
						{filter}
					</Panel>
				</Collapse>
			) : (
				<>
					{labeled && (
						<Typography.Title level={4} disabled={loading}>
							{"Tipo de Operación"}
						</Typography.Title>
					)}
					{filter}
				</>
			)}
		</div>
	);
};
